<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>
<script>
import * as echarts from "echarts";
import resize from "@/components/chart/mixins/resize";
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Object,
    },
    max: {
      type: Number,
      default() {
        return 0;
      },
    },
    min: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      timer: null,
      chart: null,
      // barColor:{'经销商': '#00FF99', '加油站': '#00FFF7', '转运站': '#00BBFF', '农资站': '#FF7B00', '维修站': '#FFBF00'},
      // barLinearColor:{'经销商': ['#00FF99', '#0F5237'], '加油站': ['#00FFF7', '#0F5452'], '转运站': ['#00BBFF', '#0F4052'], '农资站': ['#FF7B00', '#54300F'], '维修站': ['#FFBF00','#52410F']},
      // 立体柱状图颜色 [[黄色、绿色]]
      colorArr: [
        [
          "rgba(7, 125, 68, ",
          "rgba(25, 218, 125, ",
          "rgba(4, 93, 50, ",
          "rgba(3, 117, 62, ",
        ],
        [
          "rgba(125, 85, 6, ",
          "rgba(217, 152, 24, ",
          "rgba(92, 62, 4, ",
          "rgba(117, 79, 4, ",
        ],
      ],
      options: {
        tooltip: {
          show: true,
          trigger: "axis",
          borderColor: "rgba(10, 69, 31, 0.8)",
          backgroundColor: "rgba(0, 97, 56, 0.7)",
          axisPointer: {
            type: "cross",
            label: {
              color: "#ffffff",
              borderColor: "rgba(10, 69, 31, 0.8)",
              backgroundColor: "rgba(0, 97, 56, 0.7)",
            },
          },
          formatter(params) {
            let dom = "";
            let total = 0;
            let list = params;
            // list.pop();
            list.map((v, i) => {
              let itemData = list[i];
              if (
                itemData.seriesName == "转入" ||
                itemData.seriesName == "转出"
              ) {
                let marker = `<span style="display:inline-block;margin-bottom: 3px;margin-right:5px;width:12px;height:4px;border-radius: 1px;background-color:${
                  itemData.seriesName == "转入" ? "#26FF72" : "#FFAE0D"
                }"></span>`;
                dom += `
                <div style="margin: 0px 0 8px;line-height:1;">
                    <div style="margin: 0px 0 0;line-height:1;">
                      ${marker}
                      <span style="font-size:12px;color:#fff;font-weight:400;margin-left:-2px">${
                        itemData.seriesName || "--"
                      }</span>
                      <span style="float:right;margin-left:20px;font-size:14px;color:#fff;font-weight:900;">${
                        itemData.value < 1 ? 0 : itemData.value
                      }</span>
                    </div>
                  </div>`;
              }
            });

            let topDom =
              list && list.length > 0
                ? `<div style="font-size:14px;color:#fff;font-weight:400;line-height:1;margin-bottom: 8px;">${
                    list[0].axisValueLabel
                      ? list[0].axisValueLabel.split(",")[0]
                      : ""
                  }</div>`
                : "";
            return `<div style="padding: 8px 8px 0 8px;">${topDom}${dom}</div>`;
          },
          // axisPointer: {
          //   type: "cross",
          //   label: {
          //     backgroundColor: "#0A1D31",
          //   }
          // },
        },
        legend: {
          show: true,
          orient: "horizontal",
          x: "right",
          y: "top",
          top: "2%",
          rihgt: "4%",
          data: [],
          itemWidth: 16,
          itemHeight: 5,
          itemGap: 25,
          textStyle: {
            color: "#0DFFA9",
            fontSize: 12,
          },
        },
        grid: {
          right: "2%",
          left: "8%",
          top: "24%",
          bottom: "20%",
        },
        dataZoom: [
          {
            type: "slider", // 外部滑动条
            show: false,
            xAxis: [0], // 控制第一个X轴
            start: 0, // 默认展示区域起始百分比
            end: 36, // 默认展示区域结束百分比
            zoomLock: true, // 开启鼠标滚轮滚动
            disabled: true,
          },
          {
            type: "inside", // 内置滚动条
            show: false,
            xAxis: [0],
            zoomLock: true, // 开启鼠标滚轮滚动
            disabled: true,
          },
        ],
        yAxis: {
          name: "(人)",
          min: 0,
          max: 10,
          nameTextStyle: {
            color: "#BABBBD",
            fontSize: 12,
            align: "right",
            padding: [0, 24, 0, 0],
          },
          type: "value",
          axisLabel: {
            interval: 0,
            color: "#BABBBD",
            fontSize: 12,
            verticalAlign: "middle",
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          axisLine: {
            show: false,
          },
          // data: ['洛阳市', '平顶山', '南阳', '信阳']
        },
        xAxis: {
          type: "category",
          min: 0,
          nameTextStyle: {
            color: "#FFFFFF",
            fontSize: 12,
            align: "text",
            padding: [0, 0, 0, 0],
          },
          axisLabel: {
            interval: "0",
            color: "#ffffff",
            margin: 16,
            fontSize: 12,
            formatter: function (value, index) {
              const data = value.split(",");
              // 根据索引或数据内容区分城市名和数字
              const cityName = data[0]; // 城市名
              return `{cityName|${cityName}}`; // 使用定义好的 rich 样式
            },
            rich: true, // 开启富文本支持
            rich: {
              cityName: {
                color: "#BABBBD",
                fontSize: 12,
                height: 14,
              },
            },
            show: true,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.8)",
            },
            width: 5,
          },
          axisTick: {
            show: false,
            // alignWithLabel: true,
          },
          splitLine: {
            lineStyle: {
              color: "rgba(13, 255, 169, 0.1)",
            },
          },
        },
        series: [],
      },
    };
  },
  watch: {
    chartData: {
      deep: true,
      immediate: true,
      handler(val) {
        // console.log('watch.chartData::', val);
        if (this.chart) {
          this.initChart();
          if (val.labelNames && val.labelNames.length <= 7) {
            this.chart.setOption({
              dataZoom: [
                {
                  end: 100,
                },
              ],
            });
          } else {
            this.chart.setOption({
              dataZoom: [
                {
                  end: 34,
                },
              ],
            });
          }
        }
      },
    },
  },
  mounted() {
    this.initChart();
  },
  created() {},
  activated() {
    this.$nextTick(function () {
      setTimeout(() => {
        this.chart.resize();
      }, 500);
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setChartData() {
      let that = this;
      let series = [];
      if (this.chartData.list) {
        for (let index = 0; index < this.chartData.list.length; index++) {
          const el = this.chartData.list[index];
          // 为了实现立体效果，把两个柱子并在一起
          series.push({
            name: el.name,
            type: "bar",
            barGap: 0,
            barWidth: "10",
            itemStyle: {
              normal: {
                color: function (params) {
                  return new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    //渐变色在下面修改，这里是透明度
                    [
                      {
                        offset: 0,
                        color:
                          el.name == "转入"
                            ? that.colorArr[0][1] + "1)"
                            : that.colorArr[1][1] + "1)",
                      },
                      {
                        offset: 1,
                        color:
                          el.name == "转入"
                            ? that.colorArr[0][0] + "1)"
                            : that.colorArr[1][1] + "1)",
                      },
                    ]
                  );
                },
              },
            },
            data: el.count,
            z: 5,
            zlevel: 10,
          });
          series.push({
            type: "bar",
            barWidth: "10",
            barGap: 0,
            itemStyle: {
              normal: {
                color: function (params) {
                  return new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    //渐变色在下面修改，这里是透明度
                    [
                      {
                        offset: 0,
                        color:
                          el.name == "转入"
                            ? that.colorArr[0][3] + "1)"
                            : that.colorArr[1][3] + "1)",
                      },
                      {
                        offset: 1,
                        color:
                          el.name == "转入"
                            ? that.colorArr[0][2] + "1)"
                            : that.colorArr[1][2] + "1)",
                      },
                    ]
                  );
                },
              },
            },
            data: el.count,
            z: 5,
            zlevel: 10,
          });
          series.push({
            // 最下面菱形
            data: el.count,
            type: "pictorialBar",
            symbol: "diamond",
            symbolSize: [20, 10],
            symbolPosition: "end",
            symbolOffset: el.name == "转入" ? [-20, -5] : [10, -5],
            itemStyle: {
              normal: {
                color: function (params) {
                  return el.name == "转入"
                    ? that.colorArr[0][1] + "1)"
                    : that.colorArr[1][1] + "1)";
                },
              },
            },
            z: 6,
            zlevel: 10,
          });
          series.push({
            type: "bar",
            barWidth: "10",
            barGap: 0,
            itemStyle: {
              normal: {
                color: function (params) {
                  return "rgba(255,255,255,0)";
                },
              },
            },
            data: el.count,
            z: 5,
            zlevel: 10,
          });

          // series.push({
          //   name: el.name,
          //   type: "bar",
          //   barWidth: "6",
          //   barGap: '50%',
          //   emphasis: {
          //     focus: 'series'
          //   },
          //   itemStyle: {
          //     color: new echarts.graphic.LinearGradient(
          //         0, 1, 0, 0, // 渐变方向，从上到下
          //         [
          //             {offset: 0, color: this.barLinearColor[el.name][0]}, // 渐变开始位置的颜色
          //             {offset: 1, color: this.barLinearColor[el.name][1]} // 渐变结束位置的颜色
          //         ],
          //         false // 是否为对象空间渐变，这里为 false 表示使用用户空间
          //     ),
          //     // color: this.barLinearColor[el.name],
          //     borderColor: this.barColor[el.name], // 边框颜色
          //     borderWidth: 1, // 边框宽度
          //   },
          //   data: el.count,
          // });
        }

        this.options.series = Object.assign([], series);

        let that = this;
        let seriesDataCopy = null;
        let labelNamesCopy = null;
        if (
          series &&
          series[0] &&
          series[0].data &&
          series[0].data.length >= 9
        ) {
          if (that.timer) {
            clearInterval(that.timer);
          }
          that.timer = setInterval(function () {
            for (let i = 0; i < series.length; i++) {
              if (i == 0 || i == 4) {
                seriesDataCopy = series[i].data;
                seriesDataCopy.push(seriesDataCopy.shift());
                that.$set(that.options.series[i], "data", seriesDataCopy);
              }
            }
            labelNamesCopy = that.chartData.labelNames;
            labelNamesCopy.push(labelNamesCopy.shift());
            that.$set(that.options.xAxis, "data", labelNamesCopy);
            // that.$set(that.options.yAxis, 'min', that.min);
            // that.$set(that.options.yAxis, 'max', that.max);
            // console.log('this.options.yAxis.max:::',  that.options.yAxis.max );
          }, 5000); // 每2秒滚动一次
        } else {
          this.options.xAxis.data = this.chartData.labelNames;
          this.options.series = series;
        }
        this.options.yAxis.min = this.min;
        this.options.yAxis.max = this.max;
        this.chart.setOption(this.options, true); // 设置为true的话，就是notMerge，不合并,false的话，就Merge，之前的东西还保留~
      }
    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
      }
      this.setChartData();
    },
  },
};
</script>
